import {useDebounceCallback} from "../../utils/useDebounceCallback";
import {AppStore, setLoading} from "../../useAppPullState";
import {getMemberById} from "../../api/booking";
import {AddBookingStore, resetForm, setError, setMember, setMemberId} from "../modal/Booking";
import {syncMemberBookings} from "../actions/syncUserBookings";
import dayjs from "dayjs";

export function useMemberInputChange() {
    const {
        memberId,
        member,
    } = AddBookingStore.useState();

    return useDebounceCallback(e => {
        const value = e.target?.value;
        if (value != "" && value != null && value != undefined) {
            setLoading(true)

            getMemberById({SgsMemberId: `${value}`}, res => {
                setLoading(false)
                //console.log('[[useMemberInputChange]] response <<< ', res)
                if (res.status) {


                    const member = res.data.response;
                    if (!member) {
                        setMember(null);
                        setError('Jäsennumeroa ei löytynyt')
                    } else {
                        syncMemberBookings(member.SgsMemberId).then(() => {

                            const appStore = AppStore.getRawState();
                            const courseId = appStore.selected.item.id;
                            const unavailableCourses = appStore.unavailableCourses;
                            // selected date in format 29/08/2023
                            const selectedDateDayString = appStore.selected.date;
                            // today in format 29/08/2023
                            const todayDateDayString = dayjs().format('DD/MM/YYYY');
                            const isToday = selectedDateDayString === todayDateDayString;
                            const isUnavailableInAdvance = unavailableCourses.includes(courseId);
                            const haveIsTodayBooking = appStore.userTodayBookings.findIndex(item => item.date === todayDateDayString) !== -1;
                            if (isToday && haveIsTodayBooking) {
                                setError('Varaus jo tehty tälle päivälle')
                            } else if (!isToday && isUnavailableInAdvance) {
                                setError('Ennakkovarausoikeus käytetty')
                            } else {
                                setMember(member);
                                setError(null);
                            }

                        })
                    }

                } else {
                    resetForm(true);
                    setMember(null);
                }
            });
            setLoading(false)
        } else if (
            value == "" ||
            value == null ||
            value == undefined
        ) {
            setMember(null);

        }
    }, [memberId, member], 1000, (e) => {
        // console.log('[[useMemberInputChange]] call raw function')
        const value = e.target.value;
        setMemberId(value);
        setError(null);
        if (member) {
            resetForm();
            setMember(null);
        }

    })
}
